<ddos-ui-shell>
	<ddos-ui-loader></ddos-ui-loader>
	<router-outlet></router-outlet>
</ddos-ui-shell>
